import { useMutation } from "@apollo/client";
import moment from "moment";
import { GetArtifactSidebarQueryQuery } from "types/graphql-schema";

import getArtifactActivitiesQuery from "@apps/artifact-sidebar/graphql/get-artifact-activities-query";
import { buttonTheme } from "@components/button/button-constants";
import InputDatePicker from "@components/input/input-datepicker";

import updateArtifactMutation from "../graphql/update-artifact-mutation";

const ActionItemDueDate = ({
  artifact,
}: {
  artifact: GetArtifactSidebarQueryQuery["artifact"] & {
    __typename: "ActionItemArtifactNode";
  };
}) => {
  if (artifact.__typename !== "ActionItemArtifactNode") {
    throw new Error("Invalid artifact type in ActionItemDueDate");
  }

  const [updateArtifact] = useMutation(updateArtifactMutation);

  const handleSetDueDate = (date: Date | null) => {
    const dueDate = date ? moment(date).format("YYYY-MM-DD") : null;
    updateArtifact({
      variables: {
        artifactId: artifact.id,
        additionalFields: { dueDate },
      },
      optimisticResponse: {
        createOrUpdateArtifact: {
          artifact: {
            ...artifact,
            dueDate,
          },
          __typename: "CreateOrUpdateArtifactMutation",
        },
      },
      refetchQueries: [getArtifactActivitiesQuery],
    });
  };

  return (
    <InputDatePicker
      date={artifact.dueDate}
      onChangeDate={handleSetDueDate}
      isClearable={true}
      disabled={!artifact.canUpdate.permission}
      placeholderText="Due date"
      buttonProps={{ theme: buttonTheme.text }}
    />
  );
};

export default ActionItemDueDate;
